import { IconButton } from '@/components/atoms/iconButton';
import { Text } from '@/components/atoms/text';

import IconDelete from '~/svg/IconCross.svg';

type Props = {
  file: File;
  onRemove: (file: File) => void;
};

export const File = ({ file, onRemove }: Props) => {
  return (
    <div className='border-neutral-N20 mt-6 flex w-fit items-center gap-x-2 rounded-3xl border px-4 py-1'>
      <Text
        variant='body-m'
        classNames={{
          wrapper: 'text-primary-P99',
        }}
      >
        {file.name}
      </Text>
      <IconButton
        type='button'
        classNames={{ root: 'p-0 h-4 w-4' }}
        variant='text'
        color='neutral'
        slim
        size='s'
        onClick={() => onRemove(file)}
      >
        <IconDelete />
      </IconButton>
    </div>
  );
};
